import styled from 'styled-components';
import { Box } from '../Box/Box.es.js';
var VisuallyHidden = styled(Box).withConfig({
  componentId: "sc-1m0cq66-0"
})(["position:absolute !important;height:1px;width:1px;overflow:hidden;clip:rect(1px 1px 1px 1px);clip:rect(1px,1px,1px,1px);white-space:nowrap;"]);
VisuallyHidden.displayName = "VisuallyHidden";
export { VisuallyHidden };